import React from 'react';
import moment from 'moment';

import Base from 'Components/Base/Base';
import {ModalBody, ModalFooter} from 'Components/Partials/Modal';
import {Alert} from 'Components/Partials/Layouts';
import {Button, DateTimeField, Label, Select, TextArea} from 'Components/Partials/Form';

import AbsenceApi from 'Services/Api/HumanResource/Absence';

import {absenceTypeOptions} from 'Config/Options/AbsenceTypeOptions';

/**
 * @classdesc Absence Form
 */
export default class AbsenceForm extends Base {
    state = {
        form: {
            start_date: null,
            start: 'full-day',
            end_date: null,
            end: 'full-day',
            type: '',
            notes: '',
            doctors_note: '',
        },
        sick: false,
        working: false,
        alert: null,
    };

    timeOptions = [
        {value: 'full-day', label: 'Full Day'},
        {value: 'am', label: 'AM'},
        {value: 'pm', label: 'PM'},
    ];

    /**
     * @method handleSubmit
     * @param {Event} e
     * @return {Promise<void>}
     */
    handleSubmit = async (e) => {
        e.preventDefault();
        this.working();

        const data = {
            ...this.state.form,
            start_date: this.state.form.start_date !== null ?
                moment(this.state.form.start_date).format('YYYY-MM-DD') : null,
            end_date: this.state.form.end_date !== null ?
                moment(this.state.form.end_date).format('YYYY-MM-DD') : null,
        };

        if (this.props.user) {
            data['user_id'] = this.props.user.id;
        }

        const request = await AbsenceApi.create(data);

        if (request.status !== 201) {
            this.formErrors(request.message, request.errors);
            return;
        }

        if (this.props.onComplete !== undefined) {
            this.props.onComplete();
        }

        this.toastSuccess('Your absence has been logged');
    };

    /**
     * @method filterType
     * @param {{}} option
     * @param {string} time
     * @return {boolean}
     */
    filterType = (option, time) => {
        const {form} = this.state;

        return form.start_date === null ||
            form.end_date === null ||
            moment(form.end_date).diff(form.start_date, 'days') === 0 ||
            option.value !== time;
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {alert, form, working} = this.state;

        return (
            <form onSubmit={this.handleSubmit} autoComplete="off">
                <ModalBody>
                    {alert !== null && (<Alert {...alert} />)}

                    <div className="mb-4">
                        <Label label="Type" htmlFor="type"/>

                        <Select
                            value={
                                absenceTypeOptions.filter((option) => (
                                    option.value === form.type
                                ))[0]
                            }
                            options={absenceTypeOptions}
                            onChange={(option) => {
                                this.handleFormInput('type', option.value);
                            }}
                        />
                    </div>

                    <div className="mb-4">
                        <Label htmlFor="start_date" label="Start Date"/>
                        <DateTimeField id="start_date" onChange={(date) => {
                            this.handleFormInput('start_date', date);
                        }} value={form.start_date} maxDate={new Date()} dateFormat="dd/MM/yyyy"/>
                    </div>

                    <div className="mb-4">
                        <Label label="Start Time" htmlFor="start_time"/>

                        <Select
                            value={
                                this.timeOptions.filter((option) => (
                                    option.value === form.start
                                ))[0]
                            }
                            options={this.timeOptions.filter((option) => {
                                return this.filterType(option, 'am');
                            })}
                            onChange={(option) => {
                                this.handleFormInput('start', option.value);
                            }}
                        />
                    </div>

                    <div className="mb-4">
                        <Label htmlFor="end_date" label="End Date"/>
                        <DateTimeField id="end_date" onChange={(date) => {
                            this.handleFormInput('end_date', date);
                        }} value={form.end_date} minDate={form.start_date} dateFormat="dd/MM/yyyy"/>
                    </div>

                    <div className="mb-4">
                        <Label label="End Time" htmlFor="end_time"/>

                        <Select
                            value={
                                this.timeOptions.filter((option) => (
                                    option.value === form.end
                                ))[0]
                            }
                            options={this.timeOptions.filter((option) => {
                                return this.filterType(option, 'pm');
                            })}
                            onChange={(option) => {
                                this.handleFormInput('end', option.value);
                            }}
                        />
                    </div>

                    <div className="mb-4">
                        <Label htmlFor="notes" label="Notes"/>
                        <TextArea id="notes" value={form.notes} onChange={(e) => {
                            this.handleFormInput('notes', e.target.value);
                        }}/>
                    </div>
                </ModalBody>

                <ModalFooter alignment="center">
                    <Button
                        label="Cancel"
                        classKey="dangerButton"
                        type="button"
                        onClick={this.props.onClose}/>

                    <span className="ml-4">
            <Button label="Create" working={working}/>
          </span>
                </ModalFooter>
            </form>
        );
    }
}
